import { createFileRoute, redirect } from '@tanstack/react-router';

import { ForgotPasswordPage } from '@/pages/auth/forgot-password';

export const Route = createFileRoute('/(auth)/forgot-password')({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated && context.auth.user?.is_email_verified) {
      throw redirect({ to: '/courses' });
    }
  },
  component: ForgotPasswordPage,
});
